import styled from 'styled-components';
import { mediaQuery } from '@design-system/Breakpoints/Breakpoints';

export const Container = styled.div`
  padding: 11px 15px;
  background: #fafafa;
  padding-bottom: 30px;

  ${mediaQuery.desktop`
  padding: 24px 64px;
  background: #fafafa;
  padding-bottom: 320px;

  `}

  .empty {
    border: 1px solid #e0e0e0;
    background: #fff;
    border-radius: 4px;
    width: auto;
    padding: 20px;
    display: grid;
    place-items: center;
    height: 50vh;
    margin-bottom: 100px;
  }
`;

export const BasketContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;

  .shopping_basket {
    border: 1px solid #e0e0e0;
    background: #fff;
    border-radius: 4px;
    width: auto;
    padding: 20px;
  }

  .header {
    padding: 15px 12px;
    border-bottom: 1px solid #e0e0e0;
    color: #333333;
    font-size: 16px;
    font-weight: 700;
  }

  .body {
    padding: 15px;
  }

  .summary {
    border: 1px solid #e0e0e0;
    background: #fff;
    border-radius: 4px;
    width: auto;
  }

  ${mediaQuery.desktop`
  display: flex;
  flex-direction: row;
  gap: 15px;
 
  
  .shopping_basket {
    border: 1px solid #e0e0e0;
    background: #fff;
    border-radius: 4px;
    width: 850px;
  }

  .summary {
    border: 1px solid #e0e0e0;
    background: #fff;
    border-radius: 4px;
    width: 429px;
    box-sizing: border-box
    display: block;
    height: 272px;
    box-sizing: border-box;
  }
  
  `}
`;

export const CartContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 18px;
  pading-top: 15px;
  padding-left: 15px;
  margin-bottom: 18px;

  &:last-child {
    border-bottom: none;
  }

  .image {
    width: 70px;
    height: 60px;
    background: #e0e0e0;
    border-radius: 100%;
  }
  h6 {
    margin: 0;
    margin-bottom: 12px;
    color: #4f4f4f;
    font-size: 16px;
    display: none;
    font-weight: 500;
  }
  .info {
    display: flex;
    justify-content: space-between;
    width: 100%;

    h4 {
      color: #333333;
      margin: 0;
      font-size: 14px;
      font-weight: 400;
      white-space: wrap;
    }

    h5 {
      color: #4f4f4f;
      margin: 0;
      margin-top: 5px;
      font-size: 14px;
      font-weight: 400;
    }
  }

  .quantity_box {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 5px;
    width: 100px;
    display: flex;
    justify-content: flex-end;
    box-sizing: border-box;

    .content {
      display: flex;
      gap: 10px;

      input {
        width: 100%;
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        outline: none;
        border: none;
      }
    }
  }

  .sub_info {
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      color: #333333;
      font-size: 14px;
      font-weight: 700;
      margin: 0;
    }

    .delete {
      cursor: pointer;
      display: flex;
      gap: 6px;
      font-size: 14px;
      font-weight: 400;
      color: #d92d20;
      align-items: center;
    }
  }

  ${mediaQuery.desktop` 
  
  display: flex;
  align-items: flex-start;
  gap: 16px;
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 18px;
  pading-top: 15px;
  padding-left: 15px;
  margin-bottom: 18px;

  &:last-child {
    border-bottom: none;
  }

  .image {
    width: 158px;
    height: 134px;
    background: #e0e0e0;
    border-radius: 4px;
  }

  h6 {
    margin: 0;
    margin-bottom: 12px;
    color: #4F4F4F;
    font-size: 16px;
    display: block;
    font-weight: 500;
  }

  .info {
    display: flex;
    justify-content: space-between;
    width: 100%;

    h4 {
      color: #333333;
      margin: 0;
      font-size: 16px;
      font-weight: 500;
      white-space: nowrap;
    }

    h5 {
      color: #4f4f4f;
      margin: 0;
      margin-top: 8px;
      font-size: 14px;
      font-weight: 500;
    }
  }

  .quantity_box {
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    padding: 5px;
    width: 100px;
    display: flex;
    justify-content: flex-end;
    box-sizing: border-box;

    .content {
      display: flex;
      gap: 10px;

      input {
        width: 100%;
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
        outline: none;
        border: none;
      }
    }
  }

  .sub_info {
    margin-top: 19px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h3 {
      color: #333333;
      font-size: 24px;
      font-weight: 700;
      margin: 0;
    }

    .delete {
      cursor: pointer;
      display: flex;
      gap: 6px;
      font-size: 14px;
      font-weight: 500;
      color: #D92D20;
      align-items: center;
    }
  }
  
  `}
`;

export const SummaryContainer = styled.div`
  .total {
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #e0e0e0;

    h4 {
      margin: 0;
      color: #4f4f4f;
      font-size: 14px;
      font-weight: 400;
    }

    h3 {
      margin: 0;
      color: #333333;
      font-size: 14px;
      font-weight: 700;
    }
  }

  .sub_total {
    padding: 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    h4 {
      margin: 0;
      color: #4f4f4f;
      font-size: 14px;
      font-weight: 400;
    }

    h3 {
      margin: 0;
      color: #549a9a;
      font-size: 14px;
      font-weight: 700;
    }
  }

  .button {
    padding: 15px;
  }
`;

export const AccordionWrapper = styled.div`
  border: 1px solid #e0e0e0;
  background: #fff;
  border-top-radius: 4px;
  border-bottom: none;
  width: auto;
  &:last-child {
    border-bottom: 1px solid #e0e0e0;
  }

  ${mediaQuery.desktop`
  border: 1px solid #e0e0e0;
  background: #fff;
  border-top-radius: 4px;
  border-bottom: none;
  width: 850px;

  &:last-child {
    border-bottom: 1px solid #e0e0e0;
  }
  
  `}
`;

export const AccordionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: ${({ isOpen }) => (isOpen ? '1px solid #e0e0e0' : 'none')};
  cursor: pointer;
  margin: 0;
  font-size: 14px;
  font-weight: 700;
  color: #333333;

  ${mediaQuery.desktop`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  border-bottom: ${({ isOpen }) => (isOpen ? '1px solid #e0e0e0' : 'none')};
  cursor: pointer;
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #333333;
  
  `}


  .tabs {
    display: flex;
    gap: 8px;
    align-items: center;
    cursor: pointer;

    .tab-selected {
      border: 1px solid #549A9A;
      border-radius: 100%;
      background: #D4E7E7;
      width: 16px;
      height: 16px;
      display: flex;
      justify-content: center;
      align-content: center;
      align-items: center;

      .inner {
        background: #549A9A;
        width: 6px;
        height: 6px;
        border-radius: 100%;
      }
    }
`;

export const AccordionContent = styled.div`
  padding: 10px;
  display: ${({ isOpen }) => (isOpen ? 'block' : 'none')};
`;

export const ModalContainer = styled.div`
  .header {
    display: flex;
    gap: 24px;
    justify-content: center;
  }

  .title {
    text-transform: capitalize;
    padding-bottom: 8px;
    font-size: 18px;
    font-weight: 400;
    cursor: pointer;
  }

  .title_active {
    border-bottom: 3px solid #549a9a;
    padding-bottom: 8px;
    color: #549a9a;
    font-size: 18px;
    font-weight: 500;
    text-transform: capitalize;
    cursor: pointer;
  }

  form {
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-top: 24px;

    .form_content {
      display: flex;
      flex-direction: column;
    }

    .password_box {
      border: 1px solid #e0e0e0;
      width: 100%;
      box-sizing: border-box;
      height: 2.3rem;
      display: flex;
      gap: 5px;
      border-radius: 5px;
      align-content: center;
      padding-right: 3%;

      input {
        border: none;
        outline: none;
        height: auto;
        width: 100%;
        box-sizing: border-box;
        font-size: 16px;
        padding-left: 3%;
        background-color: none;

        ::placeholder {
          color: #c4c4c4;
        }

        &:focus {
          outline: none;
          border: 2px solid #549a9a;
        }
      }
    }
  }
`;
